// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doctors-page-container {
  padding: 5rem 2rem;
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* background: linear-gradient(
    135deg, 
    var(--clr-primary-9) 0%, 
    var(--clr-primary-4) 100%
  ); */
  position: relative;
}

/* Scoped h1 styling for the DoctorsPage */
.doctors-title {
  font-size: 3rem;
  color: var(--clr-primary-2);
  margin-bottom: 2rem;
  font-family: var(--ff-primary);
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1); 
}

.description {
  font-size: 1.3rem;
  color: var(--clr-grey-5);
  margin-bottom: 4rem;
  font-family: var(--ff-secondary);
}

.discipline-select-container {
  background-color: var(--clr-white);
  border-radius: var(--radius);
  box-shadow: var(--shadow-3);
  padding: 2.5rem;
  margin: 0 auto;
  max-width: 500px;
  width: 100%;
  transition: var(--transition);
  position: relative;
}

.discipline-select-container:hover {
  transform: translateY(-3px); 
  box-shadow: var(--shadow-4); 
}

.discipline-select-container label {
  margin-right: 1rem;
  font-size: 1.3rem;
  color: var(--clr-grey-1);
  display: block;
  margin-bottom: 1.2rem;
}

select {
  width: 100%;
  padding: 0.85rem;
  font-size: 1.2rem;
  border-radius: var(--radius);
  border: 2px solid var(--grey-300);
  color: var(--grey-900);
  background-color: var(--clr-white);
  box-shadow: var(--shadow-2);
  transition: var(--transition);
}

select:focus {
  outline: none;
  border-color: var(--clr-primary-5);
  box-shadow: 0 0 15px rgba(0, 150, 136, 0.6); 
}

/* Empty state message */
.empty-doctors-message {
  font-size: 1.3rem;
  color: var(--clr-grey-4);
  margin-top: 2rem;
}

/* Doctors Grid Section */
.doctors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;
  padding: 0 2rem;
  width: 100%;
  max-width: var(--max-width);
  transition: var(--transition);
}

/* Individual Doctor Cards */
.doctor-card {
  background-color: var(--clr-white);
  padding: 2.5rem;
  border-radius: var(--radius);
  box-shadow: var(--shadow-3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.doctor-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-4);
}

/* Doctor Image */
.doctor-image-container {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius) var(--radius) 0 0;
}

.doctor-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.doctor-image-container::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3); 
  transition: opacity 0.3s ease;
}

.doctor-card:hover .doctor-image-container::after {
  opacity: 0; 
}

/* Doctor Info */
.doctor-info {
  padding: 1.5rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
}

.doctors-name {
  font-size: 1.2rem;
  color: var(--clr-primary-4);
  font-family: var(--ff-primary);
  margin-bottom: 1rem;
}

.doctor-specialties {
  font-size: 1rem;
  color: var(--clr-grey-4);
  margin-bottom: 1rem;
}

.doctor-bio {
  font-size: 0.95rem;
  color: var(--clr-grey-3);
  overflow: hidden;
  max-height: 0.1rem; 
  text-overflow: ellipsis;
  margin-bottom: 1rem;
}

.doctor-card strong {
  color: var(--clr-primary-5);
}

/* Container for doctor actions */
.doctor-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem; 
  align-items: center;
  margin-top: 1.5rem; 
}

/* Action Button */
.read-more-btn {
  display: block;
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  text-align: center;
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  border-radius: var(--radius);
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.read-more-btn:hover {
  background-color: var(--clr-primary-4);
}

/* Link for "Want to see more?" */
.see-more-link {
  background-color: var(--clr-grey-3);
  color: var(--clr-white);
  padding: 0.5rem 1rem;
  text-decoration: none;
  border-radius: var(--radius);
  transition: background-color 0.3s ease;
  display: inline-block; 
  width: 100%; 
  text-align: center;
}

.see-more-link:hover {
  background-color: var(--clr-grey-4);
}

.specialty-badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin: 0.5rem;
  background-color: var(--clr-primary-9);
  color: var(--clr-primary-1);
  border-radius: 50px;
  font-size: 1rem;
  font-weight: bold;
  box-shadow: var(--shadow-1);
}

.info-box {
  background-color: var(--clr-white);
  padding: 1.5rem;
  border-radius: var(--radius);
  box-shadow: var(--shadow-3);
  margin-bottom: 2rem;
  width: 100%;
  text-align: center;
}

.info-box h3 {
  font-size: 1.5rem;
  color: var(--clr-primary-4);
  margin-bottom: 1rem;
}

.info-box p {
  font-size: 1.2rem;
  color: var(--clr-grey-5);
}

.doctor-detail-image:hover {
  transform: scale(1.05);
  transition: transform 0.3s ease;
  box-shadow: var(--shadow-4);
}

/* When expanded, allow full bio to be shown */
.doctor-bio.expanded {
  max-height: none; 
}

/* Responsive */
@media (max-width: 768px) {
  .doctors-grid {
    grid-template-columns: 1fr;
  }

  .doctor-card {
    padding: 1.8rem;
  }
}

/* Main container to center content and ensure full-page view */
.doctor-detail-container {
  background: linear-gradient(135deg, var(--clr-grey-50), var(--clr-primary-10));
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 100px); 
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: var(--clr-grey-10);
  box-shadow: var(--shadow-4);
}

/* Doctor Detail Header - image and basic info */
.doctor-detail-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--clr-white);
  border-radius: var(--radius);
  padding: 3rem;
  box-shadow: var(--shadow-2);
  width: 100%;
  margin-bottom: 3rem;
}

/* Doctor image styling */
.doctor-detail-image {
  width: 300px;
  height: 300px;
  object-fit: cover;
  border-radius: var(--radius);
  box-shadow: var(--shadow-3);
}

/* Doctor info container */
.doctor-detail-info {
  flex: 1 1;
  padding-left: 3rem;
}

.doctor-detail-info h1 {
  font-size: 2.5rem;
  color: var(--clr-primary-5);
  margin-bottom: 1rem;
  font-family: var(--ff-primary);
}

.doctor-detail-info p {
  font-size: 1.2rem;
  color: var(--clr-grey-3);
  margin-bottom: 1rem;
  line-height: 1.5;
}

/* Section for doctor full bio */
.doctor-full-bio {
  background-color: var(--clr-white);
  padding: 3rem;
  border-radius: var(--radius);
  box-shadow: var(--shadow-2);
  width: 100%;
}

.doctor-full-bio h2 {
  font-size: 2rem;
  color: var(--clr-primary-4);
  margin-bottom: 1.5rem;
  font-family: var(--ff-primary);
}

.doctor-full-bio p {
  font-size: 1.1rem;
  color: var(--clr-grey-4);
  line-height: 1.8;
}

/* Ensure this container pushes footer down on the Doctor Detail page only */
.doctor-detail-container {
  flex-grow: 1; /* Forces this section to grow and take up available space */
}

/* Scoped CSS for Doctor Detail Page */
.doctor-detail-container .doctor-detail-image {
  width: auto; 
  max-width: 100%; 
  object-fit: cover; 
  display: block; 
}

/* Responsive design */
@media (max-width: 768px) {
  .doctor-detail-header {
    flex-direction: column;
    text-align: center;
    padding: 2rem;
  }

  .doctor-detail-info {
    padding-left: 0;
    margin-top: 2rem;
  }

  .doctor-detail-image {
    width: 200px;
    height: 200px;
  }

  .doctor-full-bio {
    padding: 2rem;
  }

  .doctor-full-bio h2 {
    font-size: 1.8rem;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeIn 0.5s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/components/DoctorsPortal/DoctorsPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB;;;;MAII;EACJ,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,iCAAiC;EACjC,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;EAClC,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;EACE,mCAAmC;EACnC,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,sCAAsC;EACtC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+DAA+D;AAC/D;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kCAAkC;EAClC,aAAa;EACb,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,YAAY,EAAE,4DAA4D;AAC5E;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".doctors-page-container {\n  padding: 5rem 2rem;\n  text-align: center;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  /* background: linear-gradient(\n    135deg, \n    var(--clr-primary-9) 0%, \n    var(--clr-primary-4) 100%\n  ); */\n  position: relative;\n}\n\n/* Scoped h1 styling for the DoctorsPage */\n.doctors-title {\n  font-size: 3rem;\n  color: var(--clr-primary-2);\n  margin-bottom: 2rem;\n  font-family: var(--ff-primary);\n  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1); \n}\n\n.description {\n  font-size: 1.3rem;\n  color: var(--clr-grey-5);\n  margin-bottom: 4rem;\n  font-family: var(--ff-secondary);\n}\n\n.discipline-select-container {\n  background-color: var(--clr-white);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-3);\n  padding: 2.5rem;\n  margin: 0 auto;\n  max-width: 500px;\n  width: 100%;\n  transition: var(--transition);\n  position: relative;\n}\n\n.discipline-select-container:hover {\n  transform: translateY(-3px); \n  box-shadow: var(--shadow-4); \n}\n\n.discipline-select-container label {\n  margin-right: 1rem;\n  font-size: 1.3rem;\n  color: var(--clr-grey-1);\n  display: block;\n  margin-bottom: 1.2rem;\n}\n\nselect {\n  width: 100%;\n  padding: 0.85rem;\n  font-size: 1.2rem;\n  border-radius: var(--radius);\n  border: 2px solid var(--grey-300);\n  color: var(--grey-900);\n  background-color: var(--clr-white);\n  box-shadow: var(--shadow-2);\n  transition: var(--transition);\n}\n\nselect:focus {\n  outline: none;\n  border-color: var(--clr-primary-5);\n  box-shadow: 0 0 15px rgba(0, 150, 136, 0.6); \n}\n\n/* Empty state message */\n.empty-doctors-message {\n  font-size: 1.3rem;\n  color: var(--clr-grey-4);\n  margin-top: 2rem;\n}\n\n/* Doctors Grid Section */\n.doctors-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2.5rem;\n  margin-top: 4rem;\n  padding: 0 2rem;\n  width: 100%;\n  max-width: var(--max-width);\n  transition: var(--transition);\n}\n\n/* Individual Doctor Cards */\n.doctor-card {\n  background-color: var(--clr-white);\n  padding: 2.5rem;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-3);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.doctor-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-4);\n}\n\n/* Doctor Image */\n.doctor-image-container {\n  position: relative;\n  overflow: hidden;\n  border-radius: var(--radius) var(--radius) 0 0;\n}\n\n.doctor-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.doctor-image-container::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3); \n  transition: opacity 0.3s ease;\n}\n\n.doctor-card:hover .doctor-image-container::after {\n  opacity: 0; \n}\n\n/* Doctor Info */\n.doctor-info {\n  padding: 1.5rem;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-grow: 1;\n}\n\n.doctors-name {\n  font-size: 1.2rem;\n  color: var(--clr-primary-4);\n  font-family: var(--ff-primary);\n  margin-bottom: 1rem;\n}\n\n.doctor-specialties {\n  font-size: 1rem;\n  color: var(--clr-grey-4);\n  margin-bottom: 1rem;\n}\n\n.doctor-bio {\n  font-size: 0.95rem;\n  color: var(--clr-grey-3);\n  overflow: hidden;\n  max-height: 0.1rem; \n  text-overflow: ellipsis;\n  margin-bottom: 1rem;\n}\n\n.doctor-card strong {\n  color: var(--clr-primary-5);\n}\n\n/* Container for doctor actions */\n.doctor-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem; \n  align-items: center;\n  margin-top: 1.5rem; \n}\n\n/* Action Button */\n.read-more-btn {\n  display: block;\n  width: 100%;\n  padding: 0.75rem;\n  font-size: 1rem;\n  text-align: center;\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  border-radius: var(--radius);\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.read-more-btn:hover {\n  background-color: var(--clr-primary-4);\n}\n\n/* Link for \"Want to see more?\" */\n.see-more-link {\n  background-color: var(--clr-grey-3);\n  color: var(--clr-white);\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  border-radius: var(--radius);\n  transition: background-color 0.3s ease;\n  display: inline-block; \n  width: 100%; \n  text-align: center;\n}\n\n.see-more-link:hover {\n  background-color: var(--clr-grey-4);\n}\n\n.specialty-badge {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  margin: 0.5rem;\n  background-color: var(--clr-primary-9);\n  color: var(--clr-primary-1);\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: bold;\n  box-shadow: var(--shadow-1);\n}\n\n.info-box {\n  background-color: var(--clr-white);\n  padding: 1.5rem;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-3);\n  margin-bottom: 2rem;\n  width: 100%;\n  text-align: center;\n}\n\n.info-box h3 {\n  font-size: 1.5rem;\n  color: var(--clr-primary-4);\n  margin-bottom: 1rem;\n}\n\n.info-box p {\n  font-size: 1.2rem;\n  color: var(--clr-grey-5);\n}\n\n.doctor-detail-image:hover {\n  transform: scale(1.05);\n  transition: transform 0.3s ease;\n  box-shadow: var(--shadow-4);\n}\n\n/* When expanded, allow full bio to be shown */\n.doctor-bio.expanded {\n  max-height: none; \n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .doctors-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .doctor-card {\n    padding: 1.8rem;\n  }\n}\n\n/* Main container to center content and ensure full-page view */\n.doctor-detail-container {\n  background: linear-gradient(135deg, var(--clr-grey-50), var(--clr-primary-10));\n  padding: 4rem 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: calc(100vh - 100px); \n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  background-color: var(--clr-grey-10);\n  box-shadow: var(--shadow-4);\n}\n\n/* Doctor Detail Header - image and basic info */\n.doctor-detail-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--clr-white);\n  border-radius: var(--radius);\n  padding: 3rem;\n  box-shadow: var(--shadow-2);\n  width: 100%;\n  margin-bottom: 3rem;\n}\n\n/* Doctor image styling */\n.doctor-detail-image {\n  width: 300px;\n  height: 300px;\n  object-fit: cover;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-3);\n}\n\n/* Doctor info container */\n.doctor-detail-info {\n  flex: 1;\n  padding-left: 3rem;\n}\n\n.doctor-detail-info h1 {\n  font-size: 2.5rem;\n  color: var(--clr-primary-5);\n  margin-bottom: 1rem;\n  font-family: var(--ff-primary);\n}\n\n.doctor-detail-info p {\n  font-size: 1.2rem;\n  color: var(--clr-grey-3);\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n/* Section for doctor full bio */\n.doctor-full-bio {\n  background-color: var(--clr-white);\n  padding: 3rem;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-2);\n  width: 100%;\n}\n\n.doctor-full-bio h2 {\n  font-size: 2rem;\n  color: var(--clr-primary-4);\n  margin-bottom: 1.5rem;\n  font-family: var(--ff-primary);\n}\n\n.doctor-full-bio p {\n  font-size: 1.1rem;\n  color: var(--clr-grey-4);\n  line-height: 1.8;\n}\n\n/* Ensure this container pushes footer down on the Doctor Detail page only */\n.doctor-detail-container {\n  flex-grow: 1; /* Forces this section to grow and take up available space */\n}\n\n/* Scoped CSS for Doctor Detail Page */\n.doctor-detail-container .doctor-detail-image {\n  width: auto; \n  max-width: 100%; \n  object-fit: cover; \n  display: block; \n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .doctor-detail-header {\n    flex-direction: column;\n    text-align: center;\n    padding: 2rem;\n  }\n\n  .doctor-detail-info {\n    padding-left: 0;\n    margin-top: 2rem;\n  }\n\n  .doctor-detail-image {\n    width: 200px;\n    height: 200px;\n  }\n\n  .doctor-full-bio {\n    padding: 2rem;\n  }\n\n  .doctor-full-bio h2 {\n    font-size: 1.8rem;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.card {\n  animation: fadeIn 0.5s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
